<script>
export default {
  name: 'BxsBg',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<template functional>
  <span v-if="value" class="bxs-logo">
    <i class="iconfont icon-logo_bao" />
    <i class="iconfont icon-logo_xian" />
    <i class="iconfont icon-logo_shi" />
  </span>
</template>
<style scoped>
.bxs-logo {
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translate(-50%, 0);
  & i {
    font-size: 30px; /*px*/
    color: #508cee;
  }
}
</style>
